import jQuery from 'jquery';
import RichText from './RichText';
export default class StaticBlog {
    constructor(section) {
        this.$el = jQuery(section.el);
        this.richText = new RichText(this.$el);
    }
    onSectionUnload() {
        this.richText.unload();
    }
}
